const smallAreas = [
  {
    name: `Children's Health`,
    icon: '/small-area-icons/childrens.svg',
  },
];

export default smallAreas;



// WEBPACK FOOTER //
// ./src/helpers/small-areas.js